import { ScreenType } from './ScreenTypeContext/ScreenTypeContext';

const HEADER_HEIGHT_DESKTOP = 87;
const HEADER_HEIGHT_MOBILE = 45;

export function getHeaderHeight(screenType: ScreenType) {
  const isDesktopDevice = screenType === 'desktop' || screenType === 'laptop';

  return isDesktopDevice ? HEADER_HEIGHT_DESKTOP : HEADER_HEIGHT_MOBILE;
}
